import React from "react";
import { PatPoints } from "@prestosports/prestostats-core/Football";
import Grid from "@material-ui/core/Grid";
import { GlobalHotKeys } from "react-hotkeys";
import CardButton from "../CardButton";
import { useEventContext } from "../../../../state/events/context";
import StringFormat from "../../../../util/string-format";

const PatPointsSelectorKeyListener = ({
	scoringOptions,
	onPatPointSelected
}) => {
	const allowedKeys = [];
	scoringOptions.forEach((s) => {
		if (s.patPoints.keystroke) {
			allowedKeys.push(s.patPoints.keystroke.toLowerCase());
			allowedKeys.push(s.patPoints.keystroke.toUpperCase());
		} else {
			allowedKeys.push(`${s.configValue}`);
		}
	});

	const keyMap = {
		POINTS: allowedKeys
	};

	const handlers = {
		POINTS: (event) => {
			const scoringOption = scoringOptions.find(
				(s) =>
					(s.patPoints.keystroke &&
						s.patPoints.keystroke.toUpperCase() === event.key.toUpperCase()) ||
					`${s.configValue}` === event.key
			);

			if (scoringOption) {
				onPatPointSelected(scoringOption.patPoints);
			}
		}
	};

	return <GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges />;
};

const PatPointsSelector = ({ selected, onSelected, disableKeyListener }) => {
	const { state } = useEventContext();
	const currentEventSettings = state.currentEventSettings();
	const { gameConfiguration } = currentEventSettings;
	const { scoring } = gameConfiguration;
	const {
		scoringPatScoreOption1,
		scoringPatScoreOption2,
		scoringPatScoreOption3
	} = scoring;
	const scoringOptions = [
		{ configValue: scoringPatScoreOption1, patPoints: PatPoints.OptionOne },
		{ configValue: scoringPatScoreOption2, patPoints: PatPoints.OptionTwo },
		{ configValue: scoringPatScoreOption3, patPoints: PatPoints.OptionThree }
	];

	const getConfigurationValue = (patPointsOption) => {
		const scoringOption = scoringOptions.find(
			(s) => s.patPoints.code === patPointsOption.code
		);

		return scoringOption && scoringOption.configValue;
	};

	const getConfigurationText = (patPointsOption) => {
		const value = getConfigurationValue(patPointsOption);

		const text = value === 1 ? `${value} Point` : `${value} Points`;

		return StringFormat.formatTextWithKeystroke(
			text,
			patPointsOption.keystroke || value
		);
	};

	const onPatPointSelected = (patPoint) => {
		onSelected({ option: patPoint, value: getConfigurationValue(patPoint) });
	};

	return (
		<Grid container spacing={1}>
			{Object.values(PatPoints).map((p) => (
				<Grid item xs={12} sm={3} key={p.code}>
					<CardButton
						id={p.name}
						size="small"
						textAlign="center"
						text={getConfigurationText(p)}
						onClick={() => onPatPointSelected(p)}
						active={selected && p.code === selected.option.code}
					/>
				</Grid>
			))}
			{!disableKeyListener && (
				<PatPointsSelectorKeyListener
					scoringOptions={scoringOptions}
					onPatPointSelected={onPatPointSelected}
				/>
			)}
		</Grid>
	);
};

export default PatPointsSelector;
